import React from "react";
import { useTranslation } from "react-i18next";
import { Check, X, Boxes } from "lucide-react";

// Comparison table: DentalCAD Connect vs WhatsApp/Email/traditional flow.
export const WhyComparison = () => {
  const { t } = useTranslation();
  const rows = t("why.rows", { returnObjects: true }) || [];

  return (
    <div className="overflow-hidden rounded-xl border border-border" data-testid="why-comparison">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-secondary/50 text-left">
            <th className="px-4 py-3 font-heading text-base font-semibold">{t("why.feature")}</th>
            <th className="px-4 py-3 text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-brand px-3 py-1 text-xs font-bold text-white">
                <Boxes className="h-3.5 w-3.5" /> {t("why.us")}
              </span>
            </th>
            <th className="px-4 py-3 text-center text-xs font-semibold text-muted-foreground">{t("why.others")}</th>
          </tr>
        </thead>
        <tbody>
          {(Array.isArray(rows) ? rows : []).map((row, i) => (
            <tr key={i} className="border-t border-border transition-colors hover:bg-secondary/30" data-testid={`why-row-${i}`}>
              <td className="px-4 py-3 font-medium text-foreground">{row}</td>
              <td className="px-4 py-3 text-center">
                <Check className="mx-auto h-5 w-5 text-emerald-600" data-testid={`why-us-${i}`} />
              </td>
              <td className="px-4 py-3 text-center">
                <X className="mx-auto h-5 w-5 text-red-400" data-testid={`why-others-${i}`} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
